"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._testHook = exports.removeMostRecentSearch = exports.addToRecentSearches = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RECENT_SEARCHES_ENHANCED = 'recentSearchesEnhanced';
var ENHANCED_ORIGINAL_QUERY = 'queryEnhanced';
var MAX_RECENT_SEARCHES = 3;

var localStorageEnabled = function localStorageEnabled() {
  try {
    var store = window.localStorage;
    var key = 'test';
    store.setItem(key, key);
    store.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

var addToRecentSearches = function addToRecentSearches(searchValue) {
  var searchValueAsObject = typeof searchValue === 'string' ? {
    displayName: searchValue.trim()
  } : _objectSpread({}, searchValue);
  searchValueAsObject.display = searchValueAsObject.displayName; // backwards compatibility with old recent search implementation
  // clean up the above line once we are off of YUI recent search interface (SHO-17409)
  // Any object that gets passed in must have at least a display parameter with at least one character

  if (typeof searchValueAsObject.displayName !== 'string') {
    return;
  }

  var hasLocalStorage = localStorageEnabled();
  var lowercaseSearchDisplayString = searchValueAsObject.displayName.toLowerCase();

  if (hasLocalStorage && lowercaseSearchDisplayString.length > 0) {
    var recentSearches = [];
    var localStorageContents = localStorage.getItem(RECENT_SEARCHES_ENHANCED);

    if (localStorageContents) {
      recentSearches = JSON.parse(localStorageContents);
    }

    var lowercaseRecentSearches = recentSearches.map(function (value) {
      if (value.displayName) {
        return value.displayName.toLowerCase();
      }

      if (value.display) {
        // backwards compatibility with old
        return value.display.toLowerCase();
      }

      return '';
    });
    var searchValueIdx = lowercaseRecentSearches.findIndex(function (value) {
      return value === lowercaseSearchDisplayString;
    });

    if (searchValueIdx === -1) {
      if (recentSearches.length >= MAX_RECENT_SEARCHES) {
        recentSearches.shift();
      }

      recentSearches.push(searchValueAsObject);
      localStorage.setItem(RECENT_SEARCHES_ENHANCED, JSON.stringify(recentSearches));
    } else if (recentSearches[searchValueIdx].category === 'RAW_SEARCH' && searchValueAsObject.category === 'REGION') {
      // if a the current search is a region search and has the same displayName as a raw search, replace it in the list
      recentSearches.splice(searchValueIdx, 1);
      recentSearches.push(searchValueAsObject);
    } else {
      // If the search exists in the recent searches list, bump it to the top of the list
      recentSearches = recentSearches.concat(recentSearches.splice(searchValueIdx, 1));
    }

    localStorage.setItem(RECENT_SEARCHES_ENHANCED, JSON.stringify(recentSearches));
  }

  if (hasLocalStorage) {
    localStorage.setItem(ENHANCED_ORIGINAL_QUERY, JSON.stringify(searchValueAsObject));
  }
};

exports.addToRecentSearches = addToRecentSearches;

var removeMostRecentSearch = function removeMostRecentSearch() {
  if (localStorageEnabled()) {
    var recentSearches = JSON.parse(localStorage.getItem(RECENT_SEARCHES_ENHANCED));
    var searchValue = JSON.parse(localStorage.getItem(ENHANCED_ORIGINAL_QUERY));

    if (recentSearches) {
      var queryIndex = recentSearches.findIndex(function (value) {
        return value.displayName === searchValue.displayName;
      });

      if (queryIndex !== -1) {
        recentSearches.splice(queryIndex, 1);
        localStorage.setItem(RECENT_SEARCHES_ENHANCED, JSON.stringify(recentSearches));
      }
    }
  }
};

exports.removeMostRecentSearch = removeMostRecentSearch;
var _testHook = {
  MAX_RECENT_SEARCHES: MAX_RECENT_SEARCHES
};
exports._testHook = _testHook;
var RecentSearchClient = {
  addToRecentSearches: addToRecentSearches,
  removeMostRecentSearch: removeMostRecentSearch
};
var _default = RecentSearchClient;
exports.default = _default;